import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { DateObject } from 'src/app/models/common';
import { GridApi } from 'ag-grid-community';

@Component({
  selector: 'app-grants-outcome-assessment-view-modal',
  templateUrl: './grants-outcome-assessment-view-modal.component.html',
  styleUrls: ['./grants-outcome-assessment-view-modal.component.scss']
})
export class GrantsOutcomeAssessmentViewModalComponent implements OnInit {
  formFields;
  appid: string = "";
  outcomeAssessmentForm: UntypedFormGroup;
  maxDate = new Date();
  content: any;
  heading: string;
  action: Subject<any> = new Subject();

  formData: FormData;
  ApplicationID: any;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  gridApi: GridApi;
  ADate = new Date();
  selectedRow;
  staticformFields: any;
  rowData;
  @Input() public Content: any;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  constructor(
    private summaryService: GrantsSummaryService,
    private DatashareSerivce: GrantsDatashareService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private appFunctions: AppFunctionsService,
    public datepipe: DatePipe,
    private commonService: CommonService

  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-029');
    var grantapp = this.commonService.getGrantsApp();// "8b3a39fb-99ee-44ce-8c03-c5417eb040d2";
    this.appid = grantapp.ID;
    this.DatashareSerivce.GrantApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });

    this.outcomeAssessmentForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      ASSESSMENT_DATE: new UntypedFormControl(null, [Validators.required]),
      INSTRUMENTS: new UntypedFormControl("", [Validators.required]),
      DESCRIPTION: new UntypedFormControl("", [Validators.required]),
      IS_PLANNED: new UntypedFormControl(false),
      IS_IMPLEMENTED: new UntypedFormControl(false),
      REASON: new UntypedFormControl(""),
      ASSESSMENT_DATEO: new UntypedFormControl(null)
    });

    if (this.Content.heading === "View") {
      
      this.GetEditData();
      this.outcomeAssessmentForm.disable();
    }
    if (this.Content.heading === "Edit") {
      
      this.GetEditData();
    }

  }


  GetEditData(): void {
  
    this.summaryService.getoutcomeassessment(this.Content.content.id).subscribe(summary => {
      this.outcomeAssessmentForm.patchValue({
        ID: summary["ID"],
        APPLICATION_ID: summary["APPLICATION_ID"],
        ASSESSMENT_DATE: summary["ASSESSMENT_DATE"],
        INSTRUMENTS: summary["INSTRUMENTS"],
        DESCRIPTION: summary["DESCRIPTION"],
        IS_PLANNED: summary["IS_PLANNED"],
        IS_IMPLEMENTED: summary["IS_IMPLEMENTED"],
        REASON: summary["REASON"]
      });

      if (summary["ASSESSMENT_DATE"] != null && summary["ASSESSMENT_DATE"] != "") {
        // var formd2 = this.datepipe.transform(summary["ASSESSMENT_DATE"], 'dd-MMM-yyyy');
        // this.ADate = new Date(this.outcomeAssessmentForm.controls["ASSESSMENT_DATE"].value);
       
        this.ADate = this.commonService.getdisplayedDate(this.outcomeAssessmentForm.controls["ASSESSMENT_DATE"].value);
        this.outcomeAssessmentForm.controls["ASSESSMENT_DATE"].setValue(this.ADate);

      }
      this.extendedForm.rowid=summary.ID;
      this.extendedForm.getResponse();
    });
  }

  validateControls(): boolean {debugger;
    
    const formData = this.outcomeAssessmentForm.getRawValue();
    let isValid = true;
    let message = "";

    if(this.staticformFields?.ASSESSMENT_DATE.IS_MANDATORY && this.staticformFields?.ASSESSMENT_DATE.IS_Display){
    if (formData.ASSESSMENT_DATE === null || formData.ASSESSMENT_DATE === "" || formData.ASSESSMENT_DATE === undefined) {
      $("#ASSESSMENT_DATE").addClass("ng-touched ng-invalid validate-error");
      $("#ASSESSMENT_DATE").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.ASSESSMENT_DATE.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#ASSESSMENT_DATE").addClass("ng-untouched ng-valid");
      $("#ASSESSMENT_DATE").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if(this.staticformFields?.INSTRUMENTS.IS_MANDATORY && this.staticformFields?.INSTRUMENTS.IS_Display){  
    if (formData.INSTRUMENTS === null || formData.INSTRUMENTS === "" || formData.INSTRUMENTS === undefined) {
      $("#INSTRUMENTS").addClass("ng-touched ng-invalid validate-error");
      $("#INSTRUMENTS").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.INSTRUMENTS.LABEL_NAME} <br/>`;
      isValid = false;
    }else {
      $("#INSTRUMENTS").addClass("ng-untouched ng-valid");
      $("#INSTRUMENTS").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if(this.staticformFields?.DESCRIPTION.IS_MANDATORY && this.staticformFields?.DESCRIPTION.IS_Display){ 
    
    if (formData.DESCRIPTION === null || formData.DESCRIPTION === "" || formData.DESCRIPTION === undefined) {
      $("#DESCRIPTION").addClass("ng-touched ng-invalid validate-error");
      $("#DESCRIPTION").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.DESCRIPTION.LABEL_NAME} <br/>`;
      isValid = false;
    }
    else {
      $("#DESCRIPTION").addClass("ng-untouched ng-valid");
      $("#DESCRIPTION").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if((this.staticformFields?.IS_PLANNED.IS_MANDATORY && this.staticformFields?.IS_PLANNED.IS_Display)
  || (this.staticformFields?.IS_IMPLEMENTED.IS_MANDATORY && this.staticformFields?.IS_IMPLEMENTED.IS_Display)){ 
    debugger;
    if ((formData.IS_PLANNED == null || formData.IS_PLANNED == "" || formData.IS_PLANNED == undefined) && 
    (formData.IS_IMPLEMENTED == null || formData.IS_IMPLEMENTED == "" || formData.IS_IMPLEMENTED == undefined)) {
      $("#IS_PLANNED").addClass("ng-touched ng-invalid validate-error");
      $("#IS_PLANNED").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_PLANNED.LABEL_NAME} or ${this.staticformFields?.IS_IMPLEMENTED.LABEL_NAME}<br/>`;
      isValid = false;
    }
    else {
      $("#IS_PLANNED").addClass("ng-untouched ng-valid");
      $("#IS_PLANNED").removeClass("ng-touched ng-invalid validate-error");
    }
  }
 
  
    if (formData["IS_PLANNED"] == true) {
      if(this.staticformFields?.REASON.IS_MANDATORY && this.staticformFields?.REASON.IS_Display){
      if (formData.REASON === null || formData.REASON === "" || formData.REASON === undefined) {
        $("#REASON").addClass("ng-touched ng-invalid validate-error");
        $("#REASON").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REASON.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#REASON").addClass("ng-untouched ng-valid");
        $("#REASON").removeClass("ng-touched ng-invalid validate-error");
      }
    }
  }
    if (formData["INSTRUMENTS"] == null || formData["INSTRUMENTS"] == undefined || formData["INSTRUMENTS"] == "") {
      formData["INSTRUMENTS"] = "";
    }
    formData["APPLICATION_ID"] = this.appid;
    if (formData["ASSESSMENT_DATE"] != null && formData["ASSESSMENT_DATE"] != "") {
      formData["ASSESSMENT_DATE"] = new Date(formData["ASSESSMENT_DATE"]);
    }

  //dyamic fields validations
  let ExtenMsgs = this.extendedForm.validateControlsMsgs();
  if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
    isValid = false;
    message = message + ExtenMsgs;
  }

    if (!isValid) {
      this.commonService.ValidationBanner(message);
      
    }
    return isValid;
  }

  SaveAssessment() {
    
     if (this.validateControls()) {    
    var formData = this.outcomeAssessmentForm.getRawValue();
    formData["APPLICATION_ID"] = this.ApplicationID;
    formData["ASSESSMENT_DATEO"] = this.GetStartDate();

    if (this.Content.heading === "Add") {
      
      this.summaryService.Insert('api/gmassessment/insert', formData).subscribe(summary => {
        if (summary.Status === 0) {
          this.outcomeAssessmentForm.controls["ID"].setValue(summary.TransactionID);
          this.extendedForm.saveControls(summary.TransactionID, this.ApplicationID, summary.TransactionCode).subscribe(result => {
           
            if (result.Status === 0) {
              this.commonService.SuccessBanner(summary.Message);
              this.modalRef.close();
            }
            else
            {
              this.commonService.ValidationBanner(result.Message);
            }

          });
        }
        else {
          this.commonService.ValidationBanner(summary.message);
        }
      });
    }
    if (this.Content.heading === "Edit") {
      this.summaryService.Update('api/gmassessment/update', formData).subscribe(summary => {      
        if (summary.Status === 0  ||summary.ErrorCode=="NOCHANGES") {
          this.extendedForm.saveControls(summary.TransactionID, this.ApplicationID, summary.TransactionCode).subscribe(summary1 => {
            if(summary1.ErrorCode === "NOCONTROLS")
            {
              if (summary.Status === 0) {
                this.commonService.SuccessBanner(summary.Message);
                this.modalRef.close();
              }
              else {
                this.commonService.ValidationBanner(summary.Message);
              }
            }
            else{
              if (summary.ErrorCode === "NOCHANGES" && summary1.ErrorCode === "NOCHANGES") {
                this.commonService.ValidationBanner(summary.Message);
              }
              else {
                this.commonService.SuccessBanner(summary.Message);
                this.modalRef.close();
              }
            }
          });
        } else {
          this.commonService.ValidationBanner(summary.Message);
        }
      });
    }
  }
}

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
  isassessmentDateModified: boolean = false;
  Date: DateObject;

  assessmentDate(event) {
    
    this.isassessmentDateModified = true
    this.Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isassessmentDateModified
    }
  }

  GetStartDate(): DateObject {

    
    var formModel = this.outcomeAssessmentForm.getRawValue();
    const currentDate = new Date(formModel.ASSESSMENT_DATE);
 
    if ((this.CompareDates(this.ADate, currentDate) || this.Date == null || this.Date == undefined) && formModel.ASSESSMENT_DATE != null) {
      this.Date = {
        Day: currentDate.getDate(),
        Month: currentDate.getMonth() + 1,
        Year: currentDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    else{
      this.Date = {
        Day: currentDate.getDate(),
        Month: currentDate.getMonth() + 1,
        Year: currentDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: true
      }
    }
    return this.Date;
  }

  OnPlanned($event){
    this.outcomeAssessmentForm.controls["REASON"].setValue("");
  }
  CompareDates(olddate: any, newDate: any): boolean {
    
    if (olddate != '' && olddate != undefined && olddate != null) {

      
      let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt) { return true }
      else { return false }
    }
    else
      return false
  }
  showFiles() {
    let files = '';
    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    return files;
  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }

  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }
}
